let _ = t => t,
  _t;
import { keyframes } from 'styled-components';
import styledWithTheme from 'foundations-theming/utils';
const shimmerAnimation = keyframes(["0%{left:-50%;}100%{left:100%;}"]);
export const ACSkeletonBox = styledWithTheme.div(_t || (_t = _`
  overflow: hidden;
  position: relative;
  background-color: ${0};

  &::after {
    content: '';
    display: ${0};
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    left: -50%;
    animation: ${0} 1s cubic-bezier(0.42, 0, 0.58, 1) infinite;
    background: linear-gradient(
      to right,
      transparent 0%,
      ${0} 50%,
      transparent 100%
    );
  }
`), props => props.backgroundcolor || props.theme.color['fill-accent-neutral-subtle-alt'], props => props.animated ? 'block' : 'none', shimmerAnimation, props => props.shimmercolor || 'rgba(255, 255, 255, 0.65)');
export default ACSkeletonBox;